import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TokenService } from '../../../shared/services/token.service';
import { AuthService } from '../../../auth/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from '../../../shared/services/toaster.service';
import { BusinessEntityService } from '../../../shared/services/business-entity.service';
import { BaseResponse } from '../../../models/response';
import { GetterSetterService } from '../../../shared/services/getter-setter.service';
import { APP_NAME, UserRoleMap } from '../../../shared/constant';
import { Subject, BehaviorSubject } from 'rxjs';
import { BusinessService } from 'src/app/businessManagement/services/business.service';
import { BulkPrintService } from 'src/app/shared/services/bulk-print.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-business-header',
  templateUrl: './business-header.component.html',
  styleUrls: ['./business-header.component.scss'],
})
export class BusinessHeaderComponent implements OnInit {

  BNBusinessList: any = [];
  subArrowShow: boolean;
  BNSelectedComs: any;
  NavEntityContext: any;
  isRole: any;
  companyId: any;
  BNModel: any;
  businessName: any;
  familyData: any;
  business_role: any;
  count: number;
  gstin_count: number;
  companyList: any;
  gstnMsg: boolean;
  currentUser: String;
  selectedcom: any;
  userRole: any;
  APP_NAME: { ONYX: string; TOPAZ: string; Saphhire: string; };
  pobCodeForHeader: any;
  allEntity: any;
  pobData: any;

  constructor(
    private tokenService: TokenService,
    private authService: AuthService,
    private router: Router,
    private toaster: ToasterService,
    private entityService: BusinessEntityService,
    private GetSet: GetterSetterService,
    private getterSetter: GetterSetterService,
    private businessService: BusinessService,
    private bulkPrintService: BulkPrintService
  ) {
    this.APP_NAME = APP_NAME
    this.userRole = UserRoleMap;

    
  }

  keyword = "name";

  selectEvent(item) {
    if (!item || !this.BNModel || !this.BNModel.childCompanies || !this.BNModel.childCompanies.length) {
      return;
    }

    const parentChildDict = {};
    let targetFound = false;

    const mapParentsAndFindTarget = (company) => {
      if (company.companyId == item.id) {
        targetFound = true;
        return;
      }
      if (company.childCompanies && company.childCompanies.length) {
        for (const child of company.childCompanies) {
          parentChildDict[child.companyId] = company.companyId;
          mapParentsAndFindTarget(child);
          if (targetFound) {
            return;
          }
        }
      }
    };

    for (const child of this.BNModel.childCompanies) {
      parentChildDict[child.companyId] = this.BNModel.companyId;
      mapParentsAndFindTarget(child);
      if (targetFound) {
        break;
      }
    }

    if (!targetFound) {
      return;
    }

    const pathIds = [item.id];
    let currentId = item.id;
    const topLevelIds = this.BNModel.childCompanies.map((c) => c.companyId);
    while (topLevelIds.indexOf(currentId) === -1 && parentChildDict[currentId]) {
      currentId = parentChildDict[currentId];
      pathIds.unshift(currentId);
    }

    const topLevelCompany = this.BNModel.childCompanies.find(
      (c) => c.companyId === pathIds[0]
    );
    if (!topLevelCompany) {
      return;
    }

    let nestedCompany = topLevelCompany;
    this.onBNComSelected('', nestedCompany, 0);

    for (let i = 1; i < pathIds.length; i++) {
      const childCompanies = nestedCompany.childCompanies;
      const childCompany = childCompanies
        ? childCompanies.find((c) => c.companyId === pathIds[i])
        : null;
      if (!childCompany) {
        return;
      }
      nestedCompany = childCompany;
      this.onBNComSelected('', nestedCompany, i);
    }
  }

  onChangeSearch(search: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e) {
    // do something
  }

  ngOnInit() {
    this.initializeData();
    this.checkPremiumAccess();
    // this.initializeEntityList();
  }

  initializeData() {
    this.currentUser = sessionStorage.getItem('user');
    // let cmpId = sessionStorage.getItem('companyId');
    // this.changeBusiness(sessionStorage.getItem('companyId'));
    this.GotoUserDash();
  }

  initializeEntityList() {
    this.entityService.fetchEntity().subscribe((response: BaseResponse) => {
      if (response.status === 'SUCCESS') {
        this.BNBusinessList = response.response;
      }
    })
  }


  GotoUserDash() {
    this.NavEntityContext = { entityName: '', isTaxPayer: false, entityType: 'Business', navBarHierarchy: [] };
    this.getSetNavContext(this.NavEntityContext);
    this.BNModel = {};
    this.subArrowShow = true;
    this.BNSelectedComs = [];
    this.getBusinessHierarchy();
    this.navigateToDashboard();
  }

  navigateToDashboard() {
    const dashboardRoute = [`${this.APP_NAME.ONYX}/dashboard`];
    const currentPath = this.router.url.split('?')[0];
    const targetPath = `/${this.APP_NAME.ONYX}/dashboard`;

    if (currentPath === targetPath) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(dashboardRoute);
      });
      return;
    }

    this.router.navigate(dashboardRoute);
  }

  navigateDashboard() {
    this.navigateToDashboard();
  }

  GotoDash(com) {
    this.isRole = com.roleName;
    this.BNSelectedComs = [];
    let businessHierarchy = this.viewBusinessHierarchy(this.GetSet.getSetCompanyId());

    this.NavEntityContext = { entityName: '', isTaxPayer: false, entityType: 'Business', navBarHierarchy: [] };
    if(this.NavEntityContext && com.entityType == 'BUSINESS') {
      this.NavEntityContext.pan = com.pan;
    }
    this.getSetNavContext(this.NavEntityContext);
    this.gstnMsg = false;
    this.navigateToDashboard();
  }

  validateGstn(gstinno) {
    if (gstinno != null) {
      this.entityService.validateGstnSessionUrl(gstinno).subscribe((response: BaseResponse) => {
        if (response && response.status == 'SUCCESS' && response.response != null) {
          if (response.response.nicCredentialsVerified == 'N') {
            this.gstnMsg = true;
          } else {
            this.gstnMsg = false;
          }
        } else {
          this.gstnMsg = true;
        }
        this.setgstnConnection(!this.gstnMsg);
      }, (e) => {
        this.toaster.showError("Network Error" + e);
      })
    } else {
      this.gstnMsg = false;
    }
    //}
  }

  getSetNavContext(navContext?) {
    if (navContext) {
      // console.log('IF', navContext);
      sessionStorage.setItem('navContext', JSON.stringify(navContext));
      // this.getterSetter.checkEntityType.next(navContext);
      this.getterSetter.setBusinessData(navContext);
    } else {
      navContext = JSON.parse(sessionStorage.getItem('navContext'));
      if (!navContext) {
        navContext = { entityName: '', isTaxPayer: false }
      }
    }
    return navContext;
  }

  setgstnConnection(value) {
    if (value) {
      sessionStorage.setItem("gstnCon", value);
    } else {
      sessionStorage.setItem("gstnCon", 'false');
    }
  }

  changeBusiness(companyId) {
    if (companyId) {
      this.entityService.changeCompany(companyId).subscribe((response: BaseResponse) => {
        this.BNSelectedComs = [];
        if (response.status === 'SUCCESS') {
          if (response.response && response.response.length > 0 && response.response[0].companyid) {
            let companyId = response.response[0].companyid;
            this.getterSetter.setOnyxLite(response.response[0].isOnyxLiteAccess ? true : false);

            let company = response.response[0].company;
            this.NavEntityContext = { entityName: company, isTaxPayer: false, entityType: 'Business', navBarHierarchy: [] };
            this.getSetNavContext(this.NavEntityContext);
            this.subArrowShow = true;
            this.GetSet.getSetCompanyId(companyId);
            this.GetSet.getSetCompany(company);
            this.BNModel = {
              companyId: companyId,
              companyName: company,
              childCompanies: []
            };
            this.checkPremiumAccess();
            if(response.response[0].products.length > 0) {
              this.GetSet.setProduct(response.response[0].products);
            }
            this.toaster.showSuccess(response.message);
            this.getBusinessHierarchy(companyId, () => this.navigateToDashboard());
          }
        } else {
          this.toaster.showInfo(response)
        }
      }, (err) => {
        this.toaster.showError("Network Error!");
      });
    }
  }

  checkPremiumAccess() {
    this.bulkPrintService.fetchPremiumAccess().subscribe((response: BaseResponse) => {
      if (response.status == 'SUCCESS') {
        this.bulkPrintService.setPremiumAccess(response.response);
      }
    })
  }


  findCompanyObj(comId, obj) {
    return obj.find((com) => {
      if (comId == com.companyId)
        return com;
    }
    );
  }

  selectAllChildVal(item, childNodes) {
    if (item.childCompanies != null && item.childCompanies.length > 0) {
      for (var i = 0; i < item.childCompanies.length; i++) {
        if (item.childCompanies[i].roleName == 'Admin' || item.childCompanies[i].roleName == 'Preparer' ||
          item.childCompanies[i].roleName == 'Signatory' || item.childCompanies[i].roleName == 'Guest'
          || item.childCompanies[i].roleName == 'Maker') {
          childNodes.push({
            'name': item.childCompanies[i].companyName,
            'id': item.childCompanies[i].companyId
          });
        }

        this.selectAllChildVal(item.childCompanies[i], childNodes);
      }
      this.allEntity = childNodes;
    }
  }


  getBusinessHierarchy(companyId?: number, onComplete?: () => void) {
    let cmpId = companyId || +sessionStorage.getItem('companyId');
    let selectedEntity = null;
    this.entityService.fetchEntity().subscribe((response: BaseResponse) => {
      response.response.forEach((data) =>{
        if(data.companyid === cmpId){
          this.getterSetter.setOnyxLite(data.onyxLiteAccess ? true : false);
        }
      })
      this.BNBusinessList = response.response;
      this.BNBusinessList.sort((a,b) => a.company.localeCompare(b.company));
      if (cmpId) {
        selectedEntity = this.BNBusinessList.filter((entity) => entity.companyid == cmpId);
        
        this.GetSet.setAccessProduct('topazAccess', selectedEntity.length > 0 ? selectedEntity[0].topazAccess: false);
        this.GetSet.setAccessProduct('sapphireAccess', selectedEntity.length > 0 ? selectedEntity[0].sapphireAccess: false);
        this.GetSet.setAccessProduct('lmsAccess', selectedEntity.length > 0 ? selectedEntity[0].lmsAccess: false);
        this.entityService.fetchBusinessHierarchy(cmpId).subscribe((response: BaseResponse) => {
          this.BNModel = response.response;
          const selectedCompanyName = this.GetSet.getSetCompany();
          if (this.BNModel && selectedCompanyName && this.NavEntityContext
            && this.NavEntityContext.entityType === 'Business'
            && (!this.NavEntityContext.navBarHierarchy || !this.NavEntityContext.navBarHierarchy.length)) {
            this.BNModel.companyName = selectedCompanyName;
          } else if (this.BNModel && !this.BNModel.companyName && selectedCompanyName) {
            this.BNModel.companyName = selectedCompanyName;
          }
          this.isRole = response.response.roleName;
          this.GetSet.setGet_UserRole(this.isRole);
          this.applyHierarchyViewData(response.response);
          this.selectAllChildVal(this.BNModel, []);
          if(this.NavEntityContext && this.BNModel.entityType == 'BUSINESS') {
            this.NavEntityContext.pan = this.BNModel.pan;
          }
          if(this.BNModel.childCompanies != undefined) {
            var leng = Object.keys(this.BNModel.childCompanies).length;
            for (var i = 0; i < leng; i++) {
              this.showPath(this.BNModel.childCompanies[i]);
            }
            this.BNModel.childCompanies.sort((a,b) => a.companyName.localeCompare(b.companyName));
          }
          this.getSetNavContext(this.NavEntityContext);

          if (this.NavEntityContext && this.NavEntityContext.companyId) {
            this.companyId = this.NavEntityContext.companyId;
            var navCompanies = this.BNModel;
            this.BNSelectedComs = [];
            for (var i = 0; i < this.NavEntityContext.navBarHierarchy.length; i++) {
              navCompanies = this.findCompanyObj(this.NavEntityContext.navBarHierarchy[i], navCompanies.childCompanies);
              if (navCompanies.childCompanies != '' && navCompanies.childCompanies != null) {
                for (var j = 0; j < navCompanies.childCompanies.length; j++) {
                  this.showPath(navCompanies.childCompanies[j]);
                }
              }
              this.BNSelectedComs.push(navCompanies);
            }
          }
          if (onComplete) {
            onComplete();
          }
        }, (err) => {
          this.toaster.showError("Network Error");
          if (onComplete) {
            onComplete();
          }
        });
      }
    });
  }

  applyHierarchyViewData(hierarchyResponse) {
    if (!hierarchyResponse) {
      this.gstin_count = 0;
      return;
    }
    this.businessName = hierarchyResponse.companyName;
    this.familyData = hierarchyResponse;
    this.business_role = hierarchyResponse.roleName;
    if (hierarchyResponse.childCompanies == '') {
      this.countG([hierarchyResponse]);
    } else if (hierarchyResponse.childCompanies) {
      this.countG(hierarchyResponse.childCompanies);
    } else {
      this.gstin_count = 0;
    }
  }

  viewBusinessHierarchy(cmpId?, com?) {
    // console.log(cmpId, com, 'POPOP')
    if (com) {
      this.businessName = com.companyName;
      this.familyData = com;
      this.business_role = com.roleName;
      this.isRole = com.roleName;
      if (com.childCompanies != '') {
        this.countG(com.childCompanies);
      } else {
        this.countG([com], false);
      }
    } else if (cmpId) {
      this.entityService.fetchBusinessHierarchy(cmpId).subscribe((response: BaseResponse) => {
        if (response.status == 'SUCCESS' && response.response != null) {
          this.applyHierarchyViewData(response.response);
        } else {
          this.gstin_count = 0;
        }
        this.NavEntityContext = this.getSetNavContext();
        if (this.NavEntityContext && this.NavEntityContext.companyId) {
          if (this.NavEntityContext.childCompaniesNo) {
            this.gstin_count = this.NavEntityContext.childCompaniesNo;
          }
          this.companyId = this.NavEntityContext.companyId;
          let compHierarchy = this.familyData;
          let businessHierarchy;
          for (var i = 0; i < this.NavEntityContext.navBarHierarchy.length; i++) {
            compHierarchy = this.findCompanyObj(this.NavEntityContext.navBarHierarchy[i], compHierarchy.childCompanies);
            businessHierarchy = compHierarchy;
          }
          this.familyData = businessHierarchy;
        }

      }, (err) => {
        this.toaster.showError("Network Error");
      });
    } else {
      this.toaster.showError("No Business Entity found!");
    }
  }

  countG(obj?, isRecursive?) {

    if (!isRecursive) {
      this.count = 0;
    }
    if(obj != undefined) {
      var leng = Object.keys(obj).length;
    for (var i = 0; i < leng; i++) {
      if (obj[i].entityType == "FILING" && obj[i].roleName != 'NoRole') {
        this.count++;
      } else if (obj[i].entityType == "LEGAL") {
        this.countG(obj[i].childCompanies, true);
      }
    }
    }

    this.gstin_count = this.count;
    this.NavEntityContext.childCompaniesNo = this.count;
  }

  showPath = function (obj) {
    if (!obj) {
      return false;
    }
    var l = 0;
    if (obj.childCompanies != null && obj.childCompanies.length > 0) {
      l = obj.childCompanies.length;
    }
    if (obj.roleName != 'NoRole') {
      for (var i = 0; i < l; i++) {
        var state = this.showPath(obj.childCompanies[i]);
        if (state == true) {
          return obj.visible = true;
        }
      }
      return obj.visible = true;
    } else {
      for (var i = 0; i < l; i++) {
        var state = this.showPath(obj.childCompanies[i]);
        if (state == true) {
          return obj.visible = true;
        }
      }
      return obj.visible = false;
    }
  }


  onBNComSelected(companyName, com, index) {
    if (!com) {
      return;
    }
    this.isRole = com.roleName;
    if (com.entityType == "FILING") {
      sessionStorage.setItem('filingEntityName', companyName);
    }
    if(this.NavEntityContext && com.entityType == 'LEGAL') {
        this.NavEntityContext.pan = com.pan;
    }
    this.getSetNavContext(this.NavEntityContext);
    if (index == 0) {
      this.BNSelectedComs = [];
      this.NavEntityContext.navBarHierarchy = [];
    }
    for (var i = 0; i < this.BNSelectedComs.length; i++) {
      var isAvail = this.BNSelectedComs.findIndex(function (e) {
        if (com.parentCompanyId == e.parentCompanyId)
          return true
      });
      if (isAvail != -1) {
        this.BNSelectedComs.pop();
        this.NavEntityContext.navBarHierarchy.pop();
      }
    }
    if (com.childCompanies != null && com.childCompanies.length > 0) {
      for (var i = 0; i < com.childCompanies.length; i++) {
        this.showPath(com.childCompanies[i]);
      }
    }
    this.BNSelectedComs.push(com);
    if(com.entityType == "FILING") {
      this.entityService.setPobVal(com.childCompanies);
    }
    if(com.entityType === 'LEGAL') {
      this.entityService.setLegalHierarchy(com.childCompanies);
    }
    this.entityService.fetchFillingBusiness().subscribe((response: BaseResponse) => {
      if (response.status == 'FAILURE') {
        this.toaster.showError(response.errors[0].field);
      } else if (response.status == 'SUCCESS') {
        this.companyList = response.response;
        if (com.entityType == 'FILING') {
          var L = this.companyList.find(c => c.id == com.companyId)
          this.getSetFilling(L);
          this.GoToDashboard(com, true, L);
        } else {
          this.GoToDashboard(com, true);
        }
      }
    });
  }
  GoToDashboard(com, isForward, selectedCompObj?): any {
    if (!com) {
      return;
    }
    let companyId;
    if (!this.NavEntityContext.navBarHierarchy) {
      this.NavEntityContext.navBarHierarchy = [];
    }
    if (!isForward) {
      for (var i = this.NavEntityContext.navBarHierarchy.length - 1; i > 0; i--) {
        if (this.NavEntityContext.navBarHierarchy[i] != com.companyId) {
          this.NavEntityContext.navBarHierarchy.pop();
        }
      }
      for (var i = this.BNSelectedComs.length - 1; i > 0; i--) {
        if (this.BNSelectedComs[i].companyId != com.companyId) {
          this.BNSelectedComs.pop();
        } else
          break;
      }
    }
    this.NavEntityContext.entityType = com.entityType;
    if (this.NavEntityContext.navBarHierarchy) {
      if (this.NavEntityContext.navBarHierarchy.indexOf(com.companyId) == -1)
        this.NavEntityContext.navBarHierarchy.push(com.companyId);
    }
    this.NavEntityContext.isTaxPayer = false;

    if (com.entityType == 'FILING') {
      //            console.log(JSON.stringify(LS.get('selectedFilling')!=null ? LS.get('selectedFilling').gstin:null));
      this.NavEntityContext.isTaxPayer = true;
      this.validateGstn(JSON.parse(sessionStorage.getItem('selectedFilling')) != null ? JSON.parse(sessionStorage.getItem('selectedFilling')).gstin : null);
      if (isForward)
        this.NavEntityContext.gstin = selectedCompObj.gstin;
    } else {
      this.validateGstn(null);
    }
    this.NavEntityContext.entityName = com.companyName;
    if(com.pobCode) {
      this.NavEntityContext.pobCode = com.pobCode;
      this.pobCodeForHeader = com.pobCode;
    } else {
      this.NavEntityContext.pobCode = null;
      this.pobCodeForHeader = '';
    }
    if (com.companyId) {
      this.NavEntityContext.companyId = com.companyId;
      companyId = com.companyId;
    } else {
      companyId = this.GetSet.getSetCompanyId();
    }
    this.selectedcom = com;
    this.viewBusinessHierarchy(companyId, com);

    this.getSetNavContext(this.NavEntityContext);
    this.navigateToDashboard();

  }

  getSetFilling(selectedFilling) {
    if (selectedFilling) {
      sessionStorage.setItem('selectedFilling', JSON.stringify(selectedFilling));
    } else {
      selectedFilling = JSON.parse(sessionStorage.getItem('selectedFilling'));
    }
    return selectedFilling;
  }

  addBusiness() {
    this.router.navigate(['add-business']);
  }

  getCompanyList() {
    this.authService.comapnyList().subscribe((response: BaseResponse) => {
      if (response.status == "SUCCESS") {

      } else {
        this.toaster.showError(response.message)
      }
    });
  }

  settings(familyDataVal: any) {
    this.getterSetter.setViewHierarchyData(familyDataVal);
    this.router.navigate(['settings']);
  }

  logout() {
    if (this.tokenService.destroy()) {
      this.authService.setLoginIndicator(0);
      window.open(this.tokenService.getUumUrl(), '_self');
      // this.router.navigate(['login']);
    } else {
      this.toaster.showError('Something Went wrong !');
    }
  }

  myPreference(data: any) {
    // console.log(data, '[DARA');
    this.router.navigate([`${this.APP_NAME.ONYX}/preference`]);
  }

  checkAccessProducts(params){
    let flag = this.GetSet.getAccessProduct(params);
    return flag == 'true' ? true : false;
  }

  navigateTo(portal) {
    let authToken = sessionStorage.getItem('jwtToken') ? sessionStorage.getItem('jwtToken') : null;
    if (authToken) {
        switch (portal) {
            case 'Topaz':
              if(window.location.origin.includes("onyx-app.irisgst.com")){
                window.open(`https://topaz-app.irisgst.com/#/tokenVerify?token=${authToken}`, '_blank');
              }else{
                window.open(`https://topaz-dev.app.irisgst.com/#/tokenVerify?token=${authToken}`, '_blank');
              }
              break;
            case 'Sapphire':
                window.open(`https://asp.sapphire-app.irisgst.com/#/tokenVerify?token=${authToken}&sapphireTenent=asp`, '_blank');
                break;
            case 'LMS' :
                window.open(`${environment.lmsUrl}/token-verify?token=${authToken}`, '_blank');
                break;
        }
    }
}

}
